import { Navbar } from '../../components/Navbar';

import FarmShareBG from '../../assets/FarmshareBG.jpg';
import { Input } from '../../components/Input';
import { LocationAutocomplete } from '../../components/LocationAutocomplete';

import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentUser } from '../../redux/slices/myselfSlice';

const NewUserPage = () => {
  const [isMatch, setIsMatch] = useState(true);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    password: '',
    address: '',
    city: '',
    zip: '',
    phoneNumber: '',
  });
  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'zip' || name === 'phoneNumber') {
      const numericValue = value.replace(/\D/g, ''); // only numbers
      if (numericValue.length > 11) {
        setFormData({ ...formData, [name]: numericValue.slice(0, 11) });
        return;
      }
      setFormData({ ...formData, [name]: numericValue });
      return;
    } else if (name === 'firstName' || name === 'lastName') {
      const regex = /^[a-zA-Z]*$/; // only letters
      if (!regex.test(value)) {
        return;
      }
    } else if (name === 'password') {
      const regex = /^[a-zA-Z0-9!@#$%^&*()_+]{0,51}$/; //letters, numbers and special characters
      if (!regex.test(value)) {
        return;
      }
    }
    setFormData({ ...formData, [name]: value });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    dispatch(
      updateCurrentUser({
        firstName: formData.firstName,
        lastName: formData.lastName,
        password: confirmPassword,
        address: formData.address,
        phoneNumber: formData.phoneNumber,
        city: formData.city,
        zip: formData.zip,
      })
    );
  };

  useEffect(() => {
    if (formData.password !== confirmPassword) {
      setIsMatch(false);
    } else {
      setIsMatch(true);
    }
  }, [confirmPassword, formData.password]);

  const isPasswordLongEnough = formData.password.length >= 6;
  const canSubmit =
    isPasswordLongEnough &&
    isMatch &&
    formData.password.length <= 51 &&
    formData.firstName &&
    formData.lastName &&
    formData.address &&
    formData.city &&
    formData.phoneNumber &&
    formData.zip;

  return (
    <div>
      <Navbar src={FarmShareBG} pageName={'Registration'} />
      <div className="flex flex-col items-center justify-center min-h-screen bg-sky-200 px-4">
        <div className="mb-8 text-center max-w-md">
          <p className="text-black text-lg">
            Welcome to the Farmshare program! We'd like to get to know you better before you start
            renting equipment. Please fill in the details below.
          </p>
        </div>

        <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-6 text-center">Enter Registration Details</h2>
          <form onSubmit={handleUpdate}>
            <Input
              name="firstName"
              type="text"
              label="First Name"
              value={formData.firstName}
              onChange={handleInputChange}
              isRequired={true}
            />
            <Input
              name="lastName"
              type="text"
              label="Last Name"
              value={formData.lastName}
              onChange={handleInputChange}
              isRequired={true}
            />
            <Input
              name="password"
              type="password"
              label="Password"
              value={formData.password}
              minLength={6}
              onChange={handleInputChange}
              isRequired={true}
            />
            {formData.password.length > 0 && !isPasswordLongEnough && (
              <p className="text-red-500 text-sm mt-1">Password must be at least 6 characters</p>
            )}
            {formData.password.length > 50 && (
              <p className="text-red-500 text-sm mt-1">Password must be less than 50 characters</p>
            )}
            <Input
              name="confirmPassword"
              type="password"
              label="Confirm Password"
              onChange={(e) => {
                setConfirmPassword(e.target.value);
              }}
              isRequired={true}
            />
            {!isMatch && <p className="text-red-500 text-sm mt-2"> Password did not match</p>}
            <Input
              name="address"
              type="text"
              label="Address"
              value={formData.address}
              onChange={handleInputChange}
              isRequired={true}
            />
            <Input
              name="phoneNumber"
              type="text"
              label="Phone Number"
              value={formData.phoneNumber}
              onChange={handleInputChange}
              isRequired={true}
            />
            <LocationAutocomplete
              name="city"
              label="City"
              value={formData.city}
              onChange={handleInputChange}
              isRequired={true}
            />
            <Input
              name="zip"
              type="number"
              label="Zip Code"
              value={formData.zip}
              onChange={handleInputChange}
              isRequired={true}
            />
            <button
              type="submit"
              disabled={!canSubmit}
              className="
              w-full py-2 px-4 mt-4 rounded
              bg-[#2E7A32] text-white
              hover:bg-[#236326] transition duration-200
              disabled:opacity-50 disabled:cursor-not-allowed
            "
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export { NewUserPage };
